import React, { Component } from 'react';
import { Link } from 'react-router';
import Anchor from "../../../../../../dashboardNew/objects/Anchor";

class PodcastSeriesItem extends Component {
    render() {
        const { series, index } = this.props;


        return (
            <div key={ index } className="col-12 col-lg-6 col-xl-4 podcast-list-card">
				<Anchor path={`/training/podcasts/${ series.uid }`} anchorClass={'card-inner'} internal>
				    <div className="image" style={{backgroundImage: `url(${series.image})`}}></div>
					<div className="inner-content">
						<h3 className="heading-three">{ series.name }</h3>
						<p className="body-copy">{ series.description }</p>
					</div>
				</Anchor>
            </div>
        );
    };
}

export default PodcastSeriesItem;



// WEBPACK FOOTER //
// src/client/components/site/features/training/podcasts/series/elements/PodcastSeriesItem.js